import { Fragment } from 'react';

import { useTranslation } from 'react-i18next';
import { Provider } from '@vgtv/api-client';

import { Logo } from '../Logo/Logo';
import { Overlay } from '../Overlay/Overlay';
import { useOverlay } from '../Overlay/useOverlay';
import { config } from '../../config';
import { Button } from '../Button/Button';
import { isHermesApp } from '../../utils/device';

import { abLinks, abStaff, vgLinks, vgStaff } from './footerConfig';

import * as styles from './Footer.module.scss';

function Footer() {
  const { t } = useTranslation();
  const { isOpen, open, ariaAttributes, close } = useOverlay();

  const isVgtv = config.provider === Provider.VGTV;
  const staffList = isVgtv ? vgStaff : abStaff;
  const links = isVgtv ? vgLinks : abLinks;

  return (
    <footer className={styles.footer}>
      <p className={styles.logoContainer}>
        <Logo className={styles.logo} />
        {/* eslint-disable i18next/no-literal-string */}
        {isVgtv && (
          <Fragment>
            <br />
            Akersgata 55
            <br />
            0180 Oslo
          </Fragment>
        )}
        {/* eslint-enable i18next/no-literal-string */}
      </p>
      <div className={styles.buttons}>
        {isVgtv && (
          <Button
            onClick={open}
            size="small"
            variant="contained"
            active
            className={styles.button}
            {...ariaAttributes}
          >
            {t('upload video')}
          </Button>
        )}
        <Overlay isOpen={isOpen} onCloseButtonClick={close}>
          <iframe
            title={t('upload video')}
            width="100%"
            height="600"
            scrolling="no"
            src="https://www.filemail.com/incoming/vg02943870363?integrated"
            className={styles.fileUploadIframe}
          />
        </Overlay>

        {!isHermesApp && (
          <Button
            component="a"
            href={config.supportPageUrl}
            size="small"
            variant="outlined"
            className={styles.button}
          >
            {t('Support')}
          </Button>
        )}
        {config.provider === Provider.VGTV && (
          <Button
            component="a"
            href={config.editorialBindingsUrl}
            size="small"
            className={styles.button}
          >
            {t('Editorial connections')}
          </Button>
        )}
      </div>
      <div className={styles.staffList}>
        {staffList.map((staff, i) => {
          return (
            <div className={styles.staffRow} key={i}>
              <div className={styles.staffPosition}>{staff.staffPosition}</div>
              <div className={styles.staffName}>{staff.staffName}</div>
            </div>
          );
        })}
      </div>
      <div className={styles.border} />
      <div className={styles.links}>
        {links.map((link, i) => {
          return (
            <a
              key={i}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {link.text}
            </a>
          );
        })}
      </div>
    </footer>
  );
}

export { Footer };
